import React from 'react';

import { FormField, withFormFieldGroupFormField } from '@gogame/form';

import Partner from 'scenes/CustomAudiences/PartnerAudiences/components/PartnerAudienceForm/PartnerAudiencesFieldset/Partner';
import {
  CREDENTIALS,
  PARTNER_API_ID,
} from 'scenes/CustomAudiences/PartnerAudiences/components/PartnerAudienceForm/constants';

import {
  AutoSync,
  DataType,
  PartnerName,
  Account,
  Credentials,
} from '../fileds';
import { validationSchema } from './schema';

export const BingFieldSet = ({ value, path, externalDepends, onRemove }) => {
  const disabledAccount = !value?.[CREDENTIALS];
  return (
    <Partner
      path={path}
      depends={externalDepends}
      onRemove={onRemove}
      name={<PartnerName required={true} />}
      autoSync={<AutoSync />}
      credentials={
        <Credentials
          required={true}
          path={path}
          externalDepends={externalDepends}
        />
      }
      fields={[
        <DataType
          path={path}
          externalDepends={externalDepends}
          required={true}
        />,
        <Account
          path={path}
          externalDepends={externalDepends}
          required={true}
          disabled={disabledAccount}
        />,
        <FormField.TextField
          name={PARTNER_API_ID}
          label={'Id'}
          padding={0}
          required={true}
        />,
      ]}
    />
  );
};

export default withFormFieldGroupFormField({
  padding: 0,
  validationSchema: validationSchema,
})(BingFieldSet);
